import type { RootState } from '../store'
import { correlationSchemeWellsIdsAdapter } from './correlationSchemeWellsIdsSlice'

export const { selectAll: selectAllCorrelationSchemeWellsIds } =
  correlationSchemeWellsIdsAdapter.getSelectors<RootState>(state => state.correlationSchemeWellsIds)
